import { Button } from "../shared/button/button";
import { ContainerLogin } from "./styles";
import { LinkStyled, NormalText, TitleStyled } from "../shared/styles";
import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Announcement } from "../shared/announcement/announcement";
import {
  confirmEmailRequest,
  getAccountLinkError,
} from "../redux/actions/user.actions";

// Confirmacion con click explicito (no al montar): un scanner de links o el
// doble efecto de StrictMode no consumen el token.
export const ConfirmEmail = () => {
  const [searchParams] = useSearchParams();
  const [token] = useState(() => searchParams.get("token") || "");
  const [status, setStatus] = useState({
    isLoading: false,
    error: "",
    success: "",
  });

  useEffect(() => {
    if (window.location.search) {
      window.history.replaceState(null, "", window.location.pathname);
    }
  }, []);

  function handleConfirm() {
    if (!token) {
      setStatus({
        isLoading: false,
        error: "This link is invalid or has expired.",
        success: "",
      });
      return;
    }

    setStatus({ isLoading: true, error: "", success: "" });
    confirmEmailRequest(token)
      .then(() => {
        setStatus({
          isLoading: false,
          error: "",
          success: "Your email was updated. Use your new email to log in.",
        });
      })
      .catch((error) => {
        setStatus({
          isLoading: false,
          error: getAccountLinkError(error),
          success: "",
        });
      });
  }

  return (
    <ContainerLogin>
      <Box margin={"0 auto"}>
        <img src="/logo-tenui.png" alt="Logo Tenui" width={72} />
      </Box>
      <Box display={"flex"} flexDirection={"column"} gap={"8px"}>
        <TitleStyled>Confirm your new email</TitleStyled>
        <NormalText>
          Confirm that you want to use this email address to log in to your
          account.
        </NormalText>
      </Box>
      {!status.success && (
        <Button
          label={"Confirm email"}
          fullWidth
          onClick={handleConfirm}
          buttonStyles={{
            padding: "12px",
            minHeight: "47px",
          }}
          isLoading={status.isLoading}
        />
      )}
      <Box display={"flex"} flexDirection={"column"} gap={"8px"}>
        <LinkStyled href="/" underline="none">
          Back to login
        </LinkStyled>
      </Box>
      {status.success && (
        <Announcement title={"Success"} description={status.success} type={"info"} />
      )}
      {status.error && (
        <Announcement title={"Error"} description={status.error} type={"error"} />
      )}
    </ContainerLogin>
  );
};
